import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { GoogleSearchConsoleServiceComponent } from './GoogleSearchConsoleServiceComponent';
export const GoogleSearchConsoleReconnectionConfig = {
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED, AppConnectionStatuses.UPDATE_AVAILABLE],
  serviceComponent: GoogleSearchConsoleServiceComponent
};